import moment from 'moment';
import {UPSELLING_EXCLUDED_CATEGORIES} from '../constants/constant';

export const getUpSellingItems = (meals, categories, basketItems) => {
  const basketItemCategories = basketItems.map(item => item.mealData.categoryCode);

  // get all categories which isn't in the basket
  const upSellingCategories = categories.filter(category =>
    basketItemCategories.indexOf(category.name) === -1 &&
    UPSELLING_EXCLUDED_CATEGORIES.filter(excludedCategory => category.name.toLowerCase().indexOf(excludedCategory) > -1).length === 0
  );

  // get meals from the upSellingCategories and flat the array so we have mealUuid's only
  const upSellingMealUuids = [].concat(...upSellingCategories.map(category => category.mealUuids))
    .filter(uuid =>
      (
        meals[uuid].disabledDays.length === 0 ||
        meals[uuid].disabledDays.indexOf(moment().isoWeekday()) === -1
      )
    );

  // get random 3 items from upSellingMeals, removing the ones which already selected
  const upSellingRandomItems = Array.from(Array(3).keys())
    .map(() => {
      const randomIndex = Math.floor(Math.random() * upSellingMealUuids.length);
      return upSellingMealUuids.splice(randomIndex, 1);
    })
    .filter(item => !!item); // remove undefined items if there are no items to add

  return [].concat(...upSellingRandomItems);
};

export const sortItemByGroup = (meals, items) => {
  const grouped = {};
  items.map(item => {
    if (meals[item] && meals[item].categoryName) {
      grouped[meals[item].categoryName] = (grouped[meals[item].categoryName] || []).concat([item]);
    }
  });
  return Object.entries(grouped);
};



// WEBPACK FOOTER //
// ./helpers/upSellingHelper.js